var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center"},[_vm._m(0),_vm._t("message")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-10 h-10"},[_c('div',{staticClass:"absolute top-0 left-0 w-full h-full border-4 border-secondary-light rounded-full animate-spin",staticStyle:{"border-color":"rgb(121, 126, 246) transparent transparent transparent"}})])
}]

export { render, staticRenderFns }